import React, { FC } from 'react'

interface Props {
  width?: string
  height?: string
  stroke?: string
  className?: string
  fill?: string
}

const SvgRepeatIcon: FC<Props> = ({
  width = '20',
  height = '20',
  stroke = 'currentColor',
  className = '',
  fill = 'none',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={width}
    height={height}
    fill={fill}
    className={className}
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M10 17.083a7.083 7.083 0 004.166-12.812m-3.333 14.396L9.166 17l1.667-1.667M9.999 2.917a7.083 7.083 0 00-4.166 12.812M9.166 4.667L10.833 3 9.166 1.333"
    ></path>
  </svg>
)

export default SvgRepeatIcon
